import { push } from "connected-react-router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as UTILS from "../../../app/utils";
import {
  ROUTE_PATH,
  APPLICATION_MODE_NEW,
  DOCUMENT_TYPE_INSURANCE_CONTINURATION,
  individualFileSizeAllowedInMB,
  DOCUMENT_CONTENT_TYPE_PDF,
  APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
  REQUEST_STATUS
} from "../../../app/constants";
import {
  Header,
  Paragraph,
  Button,
  ErrorMark,
  NavigationLinkButton,
  MortgageRegulationContacts,
  MaxFileSizeUploadInstructionTextForSingleFile,
} from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import { dateValidationError, ERROR_STRING, VALIDATION_ERROR, VALIDATION_TYPE } from "../../../app/errors";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import { 
  acceptedFileFormats,
  convertFileDataForUrl,
  extractBase64, 
  fileNameWithLengthLimit, 
  fileTypeEnum, 
  validateFileName,
  fileSizeReplacement
} from "../../../app/documentUploadUtils";
import { fetchDocumentData } from "../../../redux/slice/supportingDocumentsSlice";
import { DocumentViewerFileNameLink, DownloadFileNameLink } from "../../../components/DocumentViewer/DocumentFileComponent";
import DocumentViewer from "../../../components/DocumentViewer/DocumentViewer";
import { addMortgageBrokerageInsuranceContinuationDocuments, setMortgageProperty } from "../../../redux/slice/primaryAgencyApplicationSlice";
import DateSelectionForm from "../../../components/DateSelectionForm";
import { mraPrincipalBrokerSelector } from "../../../redux/selector/mraPrincipalBrokerSelector";

export const ConfirmInsuranceProof = (props) => {

  const { isModal = false, onEditSave = () => {} } = props;

  const { principalBrokerApplication } = useSelector(
      mraPrincipalBrokerSelector
  );

  const companyRjscDetails = principalBrokerApplication?.businessLicenceData?.companyRjscDetails
  const {legalName, operatingName} = UTILS.decideLegalAndOperatingNames(companyRjscDetails)
  const companyName = (operatingName && legalName) ? `${operatingName} (${legalName})` :( operatingName ?? legalName)
  const pbFullName = principalBrokerApplication?.contactName

  const insuranceProofSelect = useSelector(
    (state) =>
      {
        let insuranceDocument = []
        const lastIssuedDate = state.primaryAgencyApplication?.application?.issuedDate;

        if(state.primaryAgencyApplication.application?.documents) {
          insuranceDocument = state.primaryAgencyApplication.application?.documents.filter(docs => (
            docs.documentType === DOCUMENT_TYPE_INSURANCE_CONTINURATION 
              && (docs.createdDate ? docs.createdDate > lastIssuedDate : true)
              && docs.changeType !== "DELETE"))
        }

        const { hasActiveErrorsOmissionsInsurance , insuranceContinuationExpiryDate } = state.primaryAgencyApplication.application?.businessLicenceData ?? {};
        
        return {
          insuranceDocument,
          hasActiveErrorsOmissionsInsurance : (hasActiveErrorsOmissionsInsurance === null || hasActiveErrorsOmissionsInsurance === undefined) ? "" : (hasActiveErrorsOmissionsInsurance ? "yes" : "no"),
          insuranceContinuationExpiryDate
        }
      }
  );

  const serverSaveRequest = useSelector(state => state.primaryAgencyApplication.serverRequestStatus)
  
  const dispatch = useDispatch();
  const applicationType = APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE;
  const applicationMode = APPLICATION_MODE_NEW;
  const [applicationSaveError, setApplicationSaveError] = useState(false);

  const [showValidationError, setShowValidationError] = useState(false);
  const [proofOfInsuranceFile, setProofOfInsuranceFile] = useState(insuranceProofSelect.insuranceDocument.length > 0 ? insuranceProofSelect.insuranceDocument[0] : {});

  const [openDocumentViewer, setOpenDocumentViewer] = useState(false)
  const [documentViewerDocument, setDocumentViewerDocument] = useState(null)
  const [selectedOption, setSelectedOption] = useState(insuranceProofSelect.hasActiveErrorsOmissionsInsurance)
  const [expiryDate, setExpiryDate] = useState(insuranceProofSelect.insuranceContinuationExpiryDate);

  const [expiryDateError, setExpiryDateError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [confimrationValidationError, setConfirmationValidationError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [documetValidationError, setDocumentValidationError] = useState(VALIDATION_ERROR.NO_ERROR);

  const validateData = () => {
    setExpiryDateError(VALIDATION_ERROR.NO_ERROR)

    let ret1 = true, ret2 = true, ret3 = true, ret4 = true

    if(typeof selectedOption === 'undefined') {
      setShowValidationError(true)
      setConfirmationValidationError(VALIDATION_ERROR.INCOMPLETE)
      ret1 = false
    }

    if(selectedOption === "no") {
      setShowValidationError(true)
      setConfirmationValidationError(VALIDATION_ERROR.SELECTION_INVALID)
      ret4 = false
    }

    // MRA-1544 : removing validation for file
    // if(!proofOfInsuranceFile || Object.keys(proofOfInsuranceFile).length === 0) {
    //   setShowValidationError(true)
    //   setDocumentValidationError(VALIDATION_ERROR.INCOMPLETE)
    //   ret2 = false
    // }

    if (UTILS.ValidateString(expiryDate, VALIDATION_TYPE.STRING_NON_EMPTY) !== VALIDATION_ERROR.NO_ERROR) {
      setExpiryDateError(VALIDATION_ERROR.DATE_INVALID)
      ret3 = false
    } else if(!UTILS.IsDateInFuture(expiryDate)){
      setExpiryDateError(VALIDATION_ERROR.DATE_NOT_IN_FUTURE)
      ret3 = false
    }

    return (ret1 && ret2 && ret3 && ret4);
  }

  const handleSaveAndNext = () => {

    setApplicationSaveError(false);
    setShowValidationError(false);

    if (!validateData()) {
      setShowValidationError(true);
      return;
    }

    dispatch(addMortgageBrokerageInsuranceContinuationDocuments(proofOfInsuranceFile))
    
    dispatch(setMortgageProperty({
      key: "hasActiveErrorsOmissionsInsurance",
      value: (selectedOption === "yes")
    }))

    dispatch(setMortgageProperty({
      key: "insuranceContinuationExpiryDate",
      value: expiryDate
    }))

    dispatch(setMortgageProperty({
      key: "mraRenewalInsuranceConfirmationDate", 
      value: new Date().getTime()
    }))

    // On to the next item
    dispatch(
      saveBusinessLicenceApplicationData(applicationType, applicationMode)
    )
      .then((data) => {
        if(isModal) {
          onEditSave()
        } else {
          dispatch(push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_RENEWAL_CONFIRM_CRIMINAL_RECORD_CHECK}`));
        }
      })
      .catch((err) => {
        // setApplicationSaveError(true);
        dispatch(push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_RENEWAL_CONFIRM_CRIMINAL_RECORD_CHECK}`));
      });
  };

  const handleFileInput = (e) => {
    if (e.target.files.length > 0) {
      let file = e.target.files[0];
      
      // individual file size can not be more than 15 MB
      if(file.size > (individualFileSizeAllowedInMB * (2 ** 20))) { 
        alert(fileSizeReplacement(ERROR_STRING.SUPPORTING_DOC_VERY_LARGE_INDIVIDUAL_FILE,individualFileSizeAllowedInMB))
        return
      } else if(!validateFileName(file.name)) {
        alert("File name is not valid. Please select another file.")
        return
      }

      let reader = new FileReader();
      reader.onload = (readerData) => {
        setProofOfInsuranceFile({
          filename: fileNameWithLengthLimit(file.name),
          documentContentType: fileTypeEnum(file.type),
          data: extractBase64(readerData.target.result),
          changeType: "SAVE",
          documentType: DOCUMENT_TYPE_INSURANCE_CONTINURATION,
          fileSize : file.size
        });
      };
      reader.readAsDataURL(file);

      // set proper file check here
      // reset validation errors
      setDocumentValidationError(VALIDATION_ERROR.NO_ERROR)
      setShowValidationError(false);
    }
  };

  const fileComponent = () => {
    const file = proofOfInsuranceFile
    return (
      <>
          <div className="supportingDocumentsFileContentWrapper">
              <span className="fileName">
                  {file.documentContentType === DOCUMENT_CONTENT_TYPE_PDF ? 
                      <DocumentViewerFileNameLink
                          id={"proof-of-insurance-file-" + file.filename}
                          key={"proof-of-insurance-file-" + file.filename}
                          file={file}
                          onClick={() => { 
                              if(file.data) { 
                                  let fileDataUrl = convertFileDataForUrl(file.data, file.documentContentType)
                                  setDocumentViewerDocument(fileDataUrl)
                                  setOpenDocumentViewer(true)
                              } else { 
                                  // download data and then view it.
                                  if(file.guid) { 
                                      dispatch(fetchDocumentData(file.guid))
                                          .then(downloadFile => {
                                              if(downloadFile) { 
                                                  let fileDataUrl = convertFileDataForUrl(downloadFile.data, downloadFile.documentContentType)
                                                  setDocumentViewerDocument(fileDataUrl)
                                                  setOpenDocumentViewer(true)
                                              }
                                          })
                                          .catch((error) => {
                                              console.error(error)
                                          })
                                  }
                              }
                          }}
                      /> : 
                      <DownloadFileNameLink
                          id={"proof-of-insurance-file-" + file.filename}
                          componentKey={"proof-of-insurance-file-" + file.filename}
                          file={file} 
                      />
                  }
              </span>
              
              <NavigationLinkButton
                  id={"proof-of-insurance-file-remove-link"}
                  text={"- Remove this file"}
                  onClick={() => {
                    if(Object.keys(proofOfInsuranceFile).length > 0) {
                      dispatch(addMortgageBrokerageInsuranceContinuationDocuments({
                        ...proofOfInsuranceFile,
                        changeType: "DELETE",
                      }))
                    }

                    setProofOfInsuranceFile({})                
                  }}
              />
          </div>
      </>
  )
  }

  return (
      <div className={!isModal ? "container" : ""}>
        {!isModal && <TopNavigationBar {...props} />}

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            {!isModal && 
            <Header
              style={{ paddingBottom: "20px" }}
              id="upload-proof-of-insurance-header"
              header="Errors and Omissions Insurance"
            />}
            <Paragraph
              id="upload-proof-of-insurance-text"
              text={[
                "To obtain a mortgage brokerage licence in Nova Scotia, your company <b>must have Errors and Omissions insurance (E&O)</b> at all times while your licence is in force, that provides extended coverage for loss resulting from fraudulent acts.",
              ]}
            />
            <Paragraph
              id="upload-proof-of-insurance-text"
              text={[
                "<b>You need enough insurance to cover at least:</b>",
                `<ul>
                  <li>$500 000 in respect of any 1 occurance involving the licensee, including, for a mortgage brokerage, any mortgage broker or associate mortgage broker authorized to broker mortgages on its behalf.</li>
                  <li>$1 000 000 to cover all claims in a 365 day period involving the licensee, including, for a mortgage brokerage, any mortgage broker or associate mortgage broker authorized to broker mortgages on its behalf.</li>
                </ul>`,
                `As a principal broker, it is your responsibility to ensure compliance with the MRA.`
              ]}
            />
          </div>
        </div>

        <div className={"row"}>
            <div className={"col-8"}>
                <h3>Do you have active Errors and Omissions insurance that meets the MRA requirements?</h3>
            </div>
            <div className={"col-8"}>
                <p><b>Please confirm:</b></p>
            </div>
            <div className="col-8">
              Yes, I, <b>{`${pbFullName}`}</b>, confirm on <b>{UTILS.humanReadableDate(new Date().getTime())}</b> that <b>{companyName}</b> has active Errors and Omissions insurance that meets the MRA requirements.
            </div>
        </div>

        <div className={"row"}>
          <div className={"col-8"}>
            <div className={
                "ns-fieldset" +
                (((confimrationValidationError !== VALIDATION_ERROR.NO_ERROR)
                  || (selectedOption === "no"))
                  ? " has-error ns-fieldset-message-error"
                  : "")
              }>
              <fieldset className={"ns-fieldset"}>
                  <div className={"ns-radios ns-radios--small"}>
                      <div 
                          key={"mra-renewal-insurance-available-yes"} 
                          className="ns-radios__item" style={{marginBottom: "15px"}}
                          onClick={() => {
                              setConfirmationValidationError(VALIDATION_ERROR.NO_ERROR)
                              setShowValidationError(false)
                              setSelectedOption("yes")
                          }}
                      >
                          <input
                              className="ns-radios__input"
                              key={"mra-renewal-insurance-available-yes-input"}
                              type={"radio"}
                              value={"yes"}
                              checked={selectedOption === "yes"}
                              onChange={(e) => {
                                      setConfirmationValidationError(VALIDATION_ERROR.NO_ERROR)
                                      setShowValidationError(false)
                                      setSelectedOption(e.target.value)
                                  }
                              }
                              id={
                                  "mra-renewal-compliance-yes-input"
                              }
                              name={"mra-renewal-insurance-available-group"}
                          />
                          <label
                              key={"mra-yes-label"}
                              id={
                              "mra-renewal-insurance-available-yes-label"
                              }
                              className="ns-radios__label"
                              htmlFor={
                              "mra-renewal-insurance-available-yes-input"
                              }
                          >
                              <span className="ns-label-span">
                                  Yes
                              </span>
                          </label>
                      </div>
                      <div 
                          key={"mra-renewal-insurance-available-no"} 
                          className="ns-radios__item"
                          onClick={() => {
                              setConfirmationValidationError(VALIDATION_ERROR.NO_ERROR)
                              setSelectedOption("no")
                          }}
                      >
                          <input
                              className="ns-radios__input"
                              key={"mra-renewal-insurance-available-no-input"}
                              type={"radio"}
                              value={"no"}
                              checked={selectedOption === "no"}
                              onChange={(e) => {
                                      setConfirmationValidationError(VALIDATION_ERROR.NO_ERROR)
                                      setSelectedOption(e.target.value)
                                  }
                              }
                              id={
                                  "mra-renewal-compliacne-no-input"
                              }
                              name={"mra-renewal-insurance-available-group"}
                          />
                          <label
                              key={"mra-no-label"}
                              id={
                              "mra-renewal-insurance-available-no-label"
                              }
                              className="ns-radios__label"
                              htmlFor={
                              "mra-renewal-insurance-available-no-input"
                              }
                          >
                              <span className="ns-label-span">
                                  No
                              </span>
                          </label>
                      </div>
                      {selectedOption === "no" && 
                          <MortgageRegulationContacts message="You must have active Errors & Omissions insurance.
                            For questions about this requirement contact:" 
                          />
                      }
                  </div>
              </fieldset>
              {confimrationValidationError === VALIDATION_ERROR.INCOMPLETE && (
                <span
                  id={"mra-renewal-insurance-available--error"}
                  className="ns-error-message field-validation-error"
                >
                   {"Select one option."}
                </span>
              )}
            </div>
          </div>
      </div>

        <div className={"row"}>
          <div className={"col-8"}>
              <h3>Continuation Certificate</h3>
          </div>
          <div className={"col-8"}>
              <p>You may upload a copy of your continuation certificate here. If not, please click continue.</p>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-8">
            {(proofOfInsuranceFile && Object.keys(proofOfInsuranceFile).length > 0) &&
            fileComponent()}
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-8">
            <div className={
                  "ns-fieldset" +
                  ((documetValidationError !== VALIDATION_ERROR.NO_ERROR)
                    ? " has-error ns-fieldset-message-error"
                    : "")
                }>
              <fieldset className="ns-fieldset" id="criminal-records-form">
                <div className={"ns-fieldset"}>
                  <label
                    className="ns-label"
                    id="upload-proof-of-insurance-file-label"
                    htmlFor="upload-proof-of-insurance-file-input"
                  >
                    Upload a file
                  </label>
                  <div className="ns-file-input">
                    <input
                      disabled={(proofOfInsuranceFile && Object.keys(proofOfInsuranceFile).length > 0)}
                      className="ns-input"
                      style={{width: "15em", display: "inline"}}
                      type="file"
                      value=""
                      accept={acceptedFileFormats(DOCUMENT_TYPE_INSURANCE_CONTINURATION).join(',')}
                      id="upload-proof-of-insurance-file-input"
                      name="upload-proof-of-insurance-file-input"
                      multiple={false}
                      onInput={handleFileInput}
                    />
                  </div>
                </div>
              </fieldset>
              {documetValidationError !== VALIDATION_ERROR.NO_ERROR && (
                <span
                  id={"mra-renewal-insurance-available-document--error"}
                  className="ns-error-message field-validation-document-error"
                >
                  {"Please upload continuation certificate."}
                </span>
              )}
            </div>
          </div>
        </div>

        <MaxFileSizeUploadInstructionTextForSingleFile />

        <div className="row">
          <div className="col-lg-8">
            <div
              className={
                "ns-fieldset" +
                (showValidationError && (expiryDateError !== VALIDATION_ERROR.NO_ERROR)
                  ? " has-error ns-fieldset-message-error"
                  : "")
              }
            >
              <fieldset className="ns-fieldset">
                <label
                  className="ns-label"
                  id={"mortgage-renewal-licence-continuation-expiry-date-label"}
                >
                  Confirm Continuation Certificate expiry :
                </label>
                <DateSelectionForm
                  id={"mortgage-renewal-licence-continuation-expiry-date"}
                  date={expiryDate}
                  showValidationError={expiryDateError !== VALIDATION_ERROR.NO_ERROR}
                  onDateChange={(date) => {
                    setExpiryDateError(VALIDATION_ERROR.NO_ERROR)
                    setExpiryDate(date)
                  }}
                />
              </fieldset>
            </div>
          </div>
        </div>

        <div className="row">
          <div className={"col-lg-4" + (showValidationError ? " has-error" : "")}>
            <Button
              id="complete-mortgage-education-continue-button"
              className="btn-lg btn-default"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={!isModal ? "Continue" : "Save and close"}
              onClick={handleSaveAndNext}
              showSpinner={!applicationSaveError && 
                (serverSaveRequest === REQUEST_STATUS.IN_PROGRESS)}
              disabled={(serverSaveRequest === REQUEST_STATUS.IN_PROGRESS)}
            />
            {(applicationSaveError || showValidationError) && ErrorMark()}
            {applicationSaveError && (
              <div className="ns-error-message help-block topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
            {showValidationError && (
              <div className="ns-error-message help-block topMarginNormal">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.CHECK_FIELDS}
            </div>
            )}
            {(expiryDateError === VALIDATION_ERROR.DATE_NOT_IN_FUTURE) && (
              <div className="ns-error-message help-block">
                <span className="ns-visually-hidden">Error:</span>
                { dateValidationError(expiryDateError) }
              </div>
            )}
          </div>
        </div>

        <DocumentViewer 
            fileData={documentViewerDocument}
            isOpen={openDocumentViewer}
            fileName={proofOfInsuranceFile?.filename}
            handleClose={() => setOpenDocumentViewer(false)}
        />

      </div>
  );
};
